import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { ApHeaderBar } from '@alixpartners/ui-components';
import { ApAuthenticationContextConsumer } from '@alixpartners/ui-utils';

import { MainHeaderRightMenu } from '../../components/MainHeaderRightMenu';
import brandPlatformsLogo from '../../assets/images/brand-platforms-logo.svg';
import { Container, Logo, LogoWrapper } from './SettingsContainer.styles';

export const SettingsContainer = () => {
  const navigate = useNavigate();
  const handleLogoClick = () => navigate('/data-manager/dashboard');

  return (
    <ApAuthenticationContextConsumer>
      {({ logout, user }) => {
        return (
          <>
            <ApHeaderBar
              logo={
                <LogoWrapper onClick={handleLogoClick}>
                  <Logo src={brandPlatformsLogo} alt="" />
                  Working Capital
                </LogoWrapper>
              }
              rightMenu={() => (
                <MainHeaderRightMenu
                  onLogout={logout}
                  userName={user?.profile?.name}
                />
              )}
            />
            <Container>
              <Outlet />
            </Container>
          </>
        );
      }}
    </ApAuthenticationContextConsumer>
  );
};
